import { WeighmentSitesAPI } from "api";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Customer"
                  className="py-2 mb-1"
                  {...register("customer")}
                  isInvalid={!!errors.customer}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.customer?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Product"
                  className="py-2 mb-1"
                  {...register("product")}
                  isInvalid={!!errors.product}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.product?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Variant"
                  className="py-2 mb-1"
                  {...register("variant")}
                  isInvalid={!!errors.variant}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.variant?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Select
                  {...register("rating")}
                  className="py-2 mb-1"
                  isInvalid={!!errors.rating}
                >
                  <option value="">Select Rating</option>
                  {[1, 2, 3, 4, 5].map((val) => (
                    <option key={val} value={val}>
                      {val}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.rating?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Feedback"
                  className="py-2 mb-1"
                  {...register("feedback")}
                  isInvalid={!!errors.feedback}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.feedback?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  className="py-2 mb-1"
                  {...register("reviewedAt")}
                  isInvalid={!!errors.reviewedAt}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.reviewedAt?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Check
                type="checkbox"
                id="defaultSwitch"
                label="Is Approved"
                defaultChecked={!state}
                isInvalid={!!errors.isApproved}
                {...register("isApproved")}
              />
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
